import http from "./httpService";

const endPoint = "/api/v1/AccountingMovement";

export function getAccMov(request) {
    return http.post(`${endPoint}`, request);
}

export default {getAccMov};


// WEBPACK FOOTER //
// ./src/services/accountingMovementService.js